import React, { Component } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import {reports} from "../../../components/Report.js";
export default class OrderLists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_detail: false,

      filter_search: "",
      filter_start_date: format_date(
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() - 1
        ),
        "yyyy-mm-dd",
        "en"
      ),
      filter_end_date: format_date(new Date(), "yyyy-mm-dd", "en"),
      filter_warehouse_id: "",
      filter_payment_type: "ชำระทันที",
      filter_status: "รอชำระ,รอสั่งสินค้า,ยกเลิก",

      data: [],
      data_warehouse: [],

      id: "",
      uid: "",
      bank_name: "",
      account_number: "",
      account_name: "",
    };

    this.tableRef = React.createRef();
  }

  async componentDidMount() {
    loading(false);
    await this.Get(0);
  }
  Get = async (page) => {
    const {
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_warehouse_id,
      filter_payment_type,
      filter_status,
    } = this.state;
    let data, data_warehouse;
    loading(true);
    let [result, result_warehouse] = await Promise.all([
      GET("admin/sales/list", {
        page: 0,
        page_size: 10000,
        data_search: filter_search,
        start_date: filter_start_date,
        end_date: filter_end_date,
        warehouse_id: filter_warehouse_id,
        payment_type: filter_payment_type,
        status_code: filter_status,
        withdrawal_type: "ขายหน้าร้าน,รอสั่งสินค้า",
      }),
      GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
    ]);
    if (result?.status) {
      data = result.data;
      let result_product = await Promise.all(
        data.map((e) => GET("admin/sales/list", { uid: e.uid }))
      );

      data = data.map((e, i) => ({
        ...e,
        transaction_list: result_product[i].data.transaction_list,
        transaction_list_vat: result_product[i].data.transaction_list_vat,
      }));
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.uid,
        label: e.name,
      }));
    }
    this.setState({
      data,
      data_warehouse,
    });
    loading(false);
  };
  render() {
    const {
      modal_detail,
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_warehouse_id,
      filter_payment_type,
      filter_status,
      data,
      data_warehouse,
      id,
      uid,
      bank_name,
      account_number,
      account_name,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">รายการสั่งซื้อ</h4>
            </div>
            <div className="d-flex align-items-center flex-wrap">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="บิลขาย, ชื่อลูกค้า, เบอร์โทร..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_start_date: e.target.value });
                }}
                value={filter_start_date}
              />
              <span className="px-2 me-2 mb-2">ถึง</span>
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_end_date: e.target.value });
                }}
                value={filter_end_date}
              />
              <select
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_status: e.target.value });
                }}
                value={filter_status}
              >
                <option value="รอชำระ,รอสั่งสินค้า,ยกเลิก">สถานะ</option>
                <option value="รอชำระ">รอชำระ</option>
                <option value="รอสั่งสินค้า">รอสั่งสินค้า</option>
                <option value="ยกเลิก">ยกเลิก</option>
              </select>
              <div className="wpx-200 me-2 mb-2">
                <Select
                  className="form-control"
                  placeholder="คลังสินค้า..."
                  options={data_warehouse}
                  onChange={(e) => {
                    this.setState({ filter_warehouse_id: e });
                  }}
                  value={filter_warehouse_id}
                />
              </div>
              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
              <div className="ms-auto">
                <button className="btn btn-warning px-3 mb-2 me-2" onClick={()=>this.ExportPDF()}>Export PDF</button>
                <DownloadTableExcel
                  filename="รายการสั่งซื้อ"
                  sheet="รายการสั่งซื้อ"
                  currentTableRef={this.tableRef.current}
                >
                  <button className="btn btn-warning px-3 mb-2">Excel</button>
                </DownloadTableExcel>
              </div>
            </div>

            <div className="table-responsive" style={{maxHeight:"70vh"}}>
              <table
                className="table rounded-3 overflow-hidden table-hover"
                ref={this.tableRef}
              >
                <thead>
                  <tr>
                    <td className="text-nowrap">วันที่</td>
                    <td className="text-nowrap">เลขที่เอกสาร</td>
                    <td className="text-nowrap">คลังสินค้า</td>
                    <td className="text-nowrap"></td>
                    <td className="text-nowrap"></td>
                    <td className="text-nowrap"></td>
                    <td className="text-nowrap"></td>
                    <td className="text-nowrap"></td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <>
                      <tr>
                        <td className="text-nowrap bg-primary-light">
                          {item.created_at
                            ? format_date(
                                item.created_at,
                                "dd/mm/yyyy hh:mm น."
                              )
                            : ""}
                        </td>
                        <td className="text-nowrap bg-primary-light">
                          {item.document_no}
                        </td>
                        <td className="text-nowrap bg-primary-light">
                          {item.warehouse?.name || "-"}
                        </td>
                        <td className="text-nowrap bg-primary-light"></td>
                        <td className="text-nowrap bg-primary-light"></td>
                        <td className="text-nowrap bg-primary-light"></td>
                        <td className="text-nowrap bg-primary-light"></td>
                        <td className="text-nowrap bg-primary-light"></td>
                      </tr>
                      <tr>
                        <td className="text-nowrap fw-bold">ลำดับ</td>
                        <td className="text-nowrap fw-bold">รหัสสินค้า</td>
                        <td className="text-nowrap fw-bold">ชื่อสินค้า</td>
                        <td className="text-nowrap fw-bold">Serial Number</td>
                        <td className="text-nowrap fw-bold text-end">จำนวน</td>
                        <td className="text-nowrap fw-bold text-end">
                          ราคาต่อหน่วย
                        </td>
                        <td className="text-nowrap fw-bold text-end">ส่วนลด</td>
                        <td className="text-nowrap fw-bold text-end">
                          จำนวนรวม
                        </td>
                      </tr>
                      {item.transaction_list.map((tx, tx_index) => (
                        <tr>
                          <td className="text-nowrap">{tx_index + 1}</td>
                          <td className="text-nowrap">{tx.product_code}</td>
                          <td className="text-nowrap">{tx.product_name}</td>
                          <td className="text-nowrap">{tx.serial_number}</td>
                          <td className="text-nowrap text-end">{tx.qty}</td>
                          <td className="text-nowrap text-end">
                            {toFixed(tx.unit_price)}
                          </td>
                          <td className="text-nowrap text-end">
                            {toFixed(tx.discount)}
                          </td>
                          <td className="text-nowrap text-end">
                            {toFixed(tx.amount)}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="text-nowrap fw-bold text-end">
                          รวมูลค่าสินค้าหรือบริการ
                        </td>
                        <td className="text-nowrap fw-bold text-end">
                          {toFixed(item.amount)}
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="text-nowrap fw-bold text-end">
                          ภาษีมูลค่าเพิ่ม
                        </td>
                        <td className="text-nowrap fw-bold text-end">
                          {toFixed(
                            item.is_vat ? Number(item.amount) * 0.07 : 0
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="text-nowrap fw-bold text-end">
                          จำนวนเงินรวมทั้งสิ้น
                        </td>
                        <td className="text-nowrap fw-bold text-end">
                          {toFixed(
                            Number(item.amount) +
                              (item.is_vat ? Number(item.amount) * 0.07 : 0)
                          )}
                        </td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
